import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      {isMenuOpen && (
        <div 
          className="navbar-backdrop" 
          onClick={() => setIsMenuOpen(false)}
          aria-hidden="true"
        />
      )}
      <nav className="navbar">
        <div className="container">
          <div className="navbar-content">
            <Link to="/" className="navbar-brand" onClick={handleLinkClick}>
              Strebla Innovations
            </Link>
            <button 
              className="navbar-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
              aria-expanded={isMenuOpen}
            >
              <span className={isMenuOpen ? 'hamburger open' : 'hamburger'}>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </button>
            <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" onClick={handleLinkClick}>Home</Link>
            <Link to="/products" onClick={handleLinkClick}>Products</Link>
            <Link to="/about" onClick={handleLinkClick}>About</Link>
            <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
            {user ? (
              <>
                {isAdmin && <Link to="/admin" onClick={handleLinkClick}>Admin</Link>}
                <span className="navbar-user">{user.email}</span>
                <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-secondary btn-sm" onClick={handleLinkClick}>
                  Login
                </Link>
                <Link to="/register" className="btn btn-primary btn-sm" onClick={handleLinkClick}>
                  Sign Up
                </Link>
              </>
            )}
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;

